import React from 'react';
import { PopupEnum, PopupMessageContent, OwnershipTransferStep, UpdateFormType } from '../Constant/Constant';
import { connect } from 'react-redux';
import { setShowPopUp, setCurrentStep, cancelOwnershipTransferRequest } from '../OwnershipTransferSlice';
import CustomerValidationResult from './CustomerValidationResult';
import ServiceAccessForm from '../../../Shared/ServiceAccessForm/ServiceAccessForm';
import RowValidationResult from './RowValidationResult';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';

const OwnershipTransferPopup = (props) => {
  function validateAccountNextStep() {
    if (props.data.currentEquipmentObligations?.length != 0) {
      props.setCurrentStep(OwnershipTransferStep.EquipmentObligations);
      props.setShowPopUp(false);
    } else {
      props.setCurrentStep(OwnershipTransferStep.CustomerForm);
      props.setShowPopUp(false);
    }
  }

  function goToDashboard() {
    props.setCurrentStep(OwnershipTransferStep.Dashboard);
    props.setShowPopUp(false);
  }

  function businessLobby() {
    EpiContext.navigateTo(Config.businessLobbyUrl);
    props.setShowPopUp(false);
  }

  function cancelOwnershipTransferRequest() {
    const rowForCancel = props.data.dashboardData.find(r => r.id == props.data.requestId);
    const editRes = {
      RequestId: rowForCancel.id,
      SubscriberNumber: rowForCancel.subscriberPhoneNumber,
      UpdateType: UpdateFormType.Cancel,
    }
    props.cancelOwnershipTransferRequest(editRes);

  }

  const popupActions = {
    closePopup: () => props.setShowPopUp(false),
    validateAccountNextStep: () => validateAccountNextStep(),
    goToDashboard: () => goToDashboard(),
    businessLobby: () => businessLobby(),
    cancelOwnershipTransferRequest: () => cancelOwnershipTransferRequest()
  };

  let currentPopUp = () => {
    switch (props.data.currentPopUp) {
      case PopupEnum.ServiceFormPopup:
        return <ServiceAccessForm setShowPopUp={props.setShowPopUp} />;
      case PopupEnum.RowValidationResult:
        return <RowValidationResult iContent={props.iContent} />;
      case PopupEnum.CustomerValidationResult:
        return (
          <CustomerValidationResult
            popupData={props.data.currentPopupData}
            buttonClick={popupActions[props.data.currentPopupData.buttonClick]}
            secondButtonClick={popupActions[props.data.currentPopupData.secondButtonClick]}
            phone={props.data.selectedPhoneNumber}
          />
        );
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
});

const mapDispatchToProps = { setShowPopUp, setCurrentStep, cancelOwnershipTransferRequest };

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferPopup);
